<ng-container *transloco="let t">
    <div
        *ngIf="titleKey"
        class="bazis-browse-default__title"
    >
        {{ t(titleKey, titleParams) }}
    </div>
    <div
        *ngIf="values.$ | async as values"
        class="bazis-text_major"
    >
        <span *ngFor="let valueId of values; let i = index">
            <ng-container *ngIf="optionsMap && optionsMap[valueId]">
                {{ optionsMap[valueId].name }}
            </ng-container>
            <ng-container *ngIf="!entityType && !optionsMap">{{ valueId }}</ng-container>
            <!-- TODO: check -->
            <ng-container *ngIf="!optionsMap && entityType">
                <ng-container *ngIf="valueId | entity : entityType | async as entity">
                    {{ entity.$snapshot.name }}
                </ng-container>
            </ng-container>
            <ng-container *ngIf="values.length > 1 && i !== values.length - 1">, </ng-container>
        </span>
    </div>
</ng-container>
